module.exports = __webpack_public_path__ + "static/media/hands.4de4cc30.png";